import {
  PartySocket
} from "./chunk-FTDRUZ5U.mjs";
import {
  useWebSocket
} from "./chunk-N2XZMCDJ.mjs";
import "./chunk-YV734IKE.mjs";

// src/react.ts
import { useEffect, useRef } from "react";
function usePartySocket(options) {
  const { onOpen, onMessage, onClose, onError, ...partySocketOptions } = options;
  const socketRef = useRef(
    new PartySocket({
      ...partySocketOptions,
      startClosed: true
      // only connect on mount
    })
  );
  useEffect(() => {
    const socket = socketRef.current;
    if (onOpen)
      socket.addEventListener("open", onOpen);
    if (onClose)
      socket.addEventListener("close", onClose);
    if (onError)
      socket.addEventListener("error", onError);
    if (onMessage)
      socket.addEventListener("message", onMessage);
    return () => {
      if (onOpen)
        socket.removeEventListener("open", onOpen);
      if (onClose)
        socket.removeEventListener("close", onClose);
      if (onError)
        socket.removeEventListener("error", onError);
      if (onMessage)
        socket.removeEventListener("message", onMessage);
    };
  }, [onOpen, onMessage, onClose, onError]);
  useEffect(
    () => {
      const socket = socketRef.current;
      if (options.startClosed !== true) {
        socket.reconnect();
      }
      return () => {
        socket.close();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return socketRef.current;
}
export {
  usePartySocket as default,
  usePartySocket,
  useWebSocket
};
